import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { SidenavLink, SidenavTabGroup } from '@healthcatalyst/cashmere';
import { Tenant } from 'src/app/shared/models/tenant';
import { readFromStorageWithDefault, writeToStorage } from 'src/app/shared/utils/local-storage.utils';
import BaseComponent from 'src/app/shared/components/base.component';
import { TenantContextService } from '../../tenant-context/tenant-context.service';

@Component({
    selector: 'cdp-tenant-sidenav',
    templateUrl: './tenant-sidenav.component.html',
    styleUrls: ['./tenant-sidenav.component.scss'],
    standalone: false
})
export class TenantSidenavComponent extends BaseComponent implements OnInit {
    @Input() tabs: SidenavLink[] = [];
    @Input() tabGroups: SidenavTabGroup[] = [];
    @Input() width = '220px';
    @Output() sidenavCollapsedChange = new EventEmitter<boolean>();

    readonly settingsStorageKey = 'CDP_TENANT_SIDEBAR_SETTINGS';

    @HostBinding('class.sidebar-is-open') isOpen = true;

    public get tenant() {
        return this.tenantService.getTenant();
    }

    public get loadingTenant() {
        return this.tenantService.loadingTenant;
    }

    public get tenantLoadFailed() {
        return this.tenantService.tenantLoadFailed;
    }

    public get isTenantActive(): boolean {
        if (this.tenant) {
            return (<Tenant>this.tenant).activeFlag;
        }

        return false;
    }

    constructor(private tenantService: TenantContextService) {
        super();
    }

    ngOnInit(): void {
        this.isOpen = readFromStorageWithDefault(this.settingsStorageKey, true);
        // Emit initial collapsed state so consumers can apply initial styles
        this.sidenavCollapsedChange.emit(!this.isOpen);
    }

    onCollapsedChange(collapsed: boolean) {
        this.isOpen = !collapsed;
        writeToStorage(this.settingsStorageKey, this.isOpen);
        this.sidenavCollapsedChange.emit(collapsed);
    }
}
